module.exports = __webpack_public_path__ + "static/Delhaize-86b4fa0c93718c6bd3a2bc080172d4de.png";